@if (badgeCount) {
  <span [class]="badge.type">{{ badgeCount }}</span>
}
